import PersonSubTree from './PersonSubTree'

export default PersonSubTree
